import { resolveItemBillingTypeClientBased } from '../../helper/helpers';

export const determineStatusColor = (value: string) => {
  switch (value) {
    case 'Created':
    case 'Not Created':
      return 'bg-slate-100 text-slate-700';
    case 'Sent':
      return 'bg-blue-100 text-blue-800';
    case 'Acknowledged':
      return 'bg-indigo-100 text-indigo-800';
    case 'Partially Received':
    case 'Partial':
      return 'bg-amber-100 text-amber-800';
    case 'Received':
    case 'Yes':
    case 'yes':
    case 'Paid':
      return 'bg-green-100 text-green-800';
    case 'Closed':
      return 'bg-emerald-100 text-emerald-800';
    case 'Canceled':
    case 'No':
    case 'no':
    case 'Not Paid':
      return 'bg-red-100 text-red-800';
    default:
      return '';
  }
};

export const componentQuantity = (d: any) => {
  if (d?.order?.orderType !== 'purchased-goods') {
    let quantity = '-';
    let quantityNumber = 1;

    switch (d?.source) {
      case 'drapery-fabric':
        if (isNaN(d?.componentType)) {
          quantity = d?.hardware?.hardwareQuantity || d?.headrail?.quantity || '-';
          quantityNumber = d?.hardware?.hardwareQuantity || d?.headrail?.quantity || 1;
        } else {
          if (d?.component?.yardsNeeded) {
            quantity = `${d?.component?.yardsNeeded} yards`;
            quantityNumber = d?.component?.yardsNeeded || 1;
          } else {
            quantity = d?.component?.qty || d?.component?.draperyOrderSummaryComponent?.qty || '-';
            quantityNumber =
              d?.component?.qty || d?.component?.draperyOrderSummaryComponent?.qty || 1;
          }
        }
        break;
      case 'drapery-summary-component':
        if (d?.component?.draperyOrderSummaryComponent?.isStaticHardware) {
          quantity = d?.hardware?.hardwareQuantity || d?.headrail?.quantity || '-';
          quantityNumber = d?.hardware?.hardwareQuantity || d?.headrail?.quantity || 1;
        }
        break;
      default:
        quantity = '-';
        quantityNumber = 1;
        break;
    }
    return {
      quantity,
      quantityNumber,
    };
  } else if (d?.order?.orderType === 'purchased-goods') {
    if (d?.order?.purchasedGoodsComponentsType === 'components-build') {
      let quantity = d?.component?.qty || '-';
      let quantityNumber = d?.component?.qty || 1;

      return {
        quantity,
        quantityNumber,
      };
    } else {
      let quantity =
        d?.order?.purchasedGoodsComponents?.find((f: any) => f.type === 'totalOnly')?.qty || '-';
      let quantityNumber =
        d?.order?.purchasedGoodsComponents?.find((f: any) => f.type === 'totalOnly')?.qty || 1;

      return {
        quantity,
        quantityNumber,
      };
    }
  } else {
    return {
      quantity: '-',
      quantityNumber: 1,
    };
  }
};

export const determineNonMyShopItemDescription = (rc: any) => {
  if (rc?.order?.orderType === 'purchased-goods') {
    if (rc?.order?.purchasedGoodsComponentsType === 'components-build') {
      return rc?.component?.item?.orderingDescription || '-';
    } else {
      let foundComponent = rc?.order?.purchasedGoodsComponents?.find(
        (f: any) => f.type === 'totalOnly'
      );
      if (foundComponent) {
        return foundComponent?.estimateDescription || '-';
      }
      return '-';
    }
  } else {
    let desc = '-';
    switch (rc?.source) {
      case 'drapery-fabric':
        if (isNaN(rc?.componentType)) {
          desc = rc?.hardware?.hardwareDescription || rc?.headrail?.estimateDescription || '-';
        } else {
          desc = rc?.component?.patternObj?.orderingDescription || rc?.component?.pattern || '-';
        }
        break;
      case 'drapery-summary-component':
        if (rc?.component?.draperyOrderSummaryComponent?.isStaticHardware) {
          desc = rc?.hardware?.hardwareDescription || rc?.headrail?.estimateDescription || '-';
        }
        break;
      default:
        desc = '-';
        break;
    }
    return desc;
  }
};

export const determineItemCost = (rc: any, client: any) => {
  let itemFabric = rc?.component?.patternObj || rc?.component?.item || null;

  let specialPriceBool = !resolveItemBillingTypeClientBased(client, itemFabric)?.method?.includes(
    'markUp'
  );
  let specialPrice = Number(resolveItemBillingTypeClientBased(client, itemFabric)?.value) || 0;
  let markUpPrice = !specialPriceBool
    ? Number(itemFabric?.cost) || 0
    : // *
      //   (1 + Number(resolveItemBillingTypeClientBased(client, itemFabric)?.value) / 100)
      0;

  if (rc?.order?.orderType === 'purchased-goods') {
    let cost = 0;

    if (rc?.order?.purchasedGoodsComponentsType === 'components-build') {
      cost = specialPriceBool ? specialPrice : Number(rc?.component?.cost) || 0;
    } else {
      let foundComponent = rc?.order?.purchasedGoodsComponents?.find(
        (f: any) => f.type === 'totalOnly'
      );
      if (foundComponent) {
        cost = Number(foundComponent?.cost) || 0;
      } else {
        cost = 0;
      }
    }

    return cost;
  } else {
    let cost = 0;
    switch (rc?.source) {
      case 'drapery-fabric':
        if (rc?.component?.name === 'HEADRAIL') {
          cost = Number(rc?.headrail?.cost) || 0;
        } else {
          cost = specialPriceBool ? specialPrice : markUpPrice;
        }
        break;
      case 'drapery-summary-component':
        cost = Number(rc?.hardware?.hardwareUnitPrice) || 0;
        break;
      default:
        cost = 0;
        break;
    }
    return cost;
  }
};
